declare global {
  interface Window {
    VUE_APP_CARESHIP_CONFIG: {
      apiUrl: string
      trackingBaseUrl: string
      baseUrl: string
      translationsUrl: string
      oAuthClientId: string
      oAuthClientSecret: string
      googleMapsKey: string
      logLevel: string
      logUrl: string
    }
  }
}

const stripTrailingSlash = str => str.replace(/\/+$/, '')

const apiUrl = stripTrailingSlash(
  process.env.VUE_APP_API_URL || window.VUE_APP_CARESHIP_CONFIG.apiUrl,
)

const baseUrl = stripTrailingSlash(
  process.env.VUE_APP_PUBLIC_PATH || window.VUE_APP_CARESHIP_CONFIG.baseUrl,
)

const translationsUrl = stripTrailingSlash(
  process.env.VUE_APP_TRANSLATIONS_URL ||
    window.VUE_APP_CARESHIP_CONFIG.translationsUrl,
)

const trackingBaseUrl = stripTrailingSlash(
  process.env.VUE_APP_TRACKING_URL ||
    window.VUE_APP_CARESHIP_CONFIG.trackingBaseUrl,
)

const gtmEventName = 'careship-app'

const oAuthClientId =
  process.env.VUE_APP_OAUTH_CLIENT_ID ||
  window.VUE_APP_CARESHIP_CONFIG.oAuthClientId

const oAuthClientSecret =
  process.env.VUE_APP_OAUTH_CLIENT_SECRET ||
  window.VUE_APP_CARESHIP_CONFIG.oAuthClientSecret

const requestTimeout = 20000

const googleMapsKey =
  process.env.VUE_APP_GOOGLE_MAPS_KEY ||
  window.VUE_APP_CARESHIP_CONFIG.googleMapsKey

const logUrl =
  process.env.VUE_APP_LOG_URL || window.VUE_APP_CARESHIP_CONFIG.logUrl

const logLevel =
  (process.env.VUE_APP_LOG_LEVEL &&
    parseInt(process.env.VUE_APP_LOG_LEVEL, 10)) ||
  (window.VUE_APP_CARESHIP_CONFIG.logLevel &&
    parseInt(window.VUE_APP_CARESHIP_CONFIG.logLevel, 10))

export {
  apiUrl,
  baseUrl,
  gtmEventName,
  oAuthClientId,
  oAuthClientSecret,
  requestTimeout,
  translationsUrl,
  googleMapsKey,
  logUrl,
  logLevel,
  trackingBaseUrl,
}
